import { useEffect } from 'react';

import { api } from '@/lib/api';

// URL del bundle standalone (apps/chat-widget en control-interno) y base de
// su API — sin configurar, el widget simplemente no se monta (no bloquea el
// resto de la app). Ver .env.example.
const WIDGET_SCRIPT_URL = import.meta.env.VITE_CRM_CHAT_WIDGET_URL as string | undefined;
const CRM_API_BASE_URL = import.meta.env.VITE_CRM_API_BASE_URL as string | undefined;

// Monta el widget de chat en vivo del CRM control-interno: pide un token de
// sesión al propio backend (que ya está de confianza ante el CRM vía
// X-API-Key, ver modules/chat/chat.controller.ts) y lo pasa al script del
// widget vía data-attributes — el widget se autoinicia solo (ver
// apps/chat-widget/src/main.ts::autoInit en control-interno).
export function useChatWidget(): void {
  useEffect(() => {
    if (!WIDGET_SCRIPT_URL || !CRM_API_BASE_URL) return;

    let cancelled = false;
    let scriptEl: HTMLScriptElement | null = null;

    api
      .get<{ token: string }>('/chat/token')
      .then(({ data }) => {
        if (cancelled) return;
        scriptEl = document.createElement('script');
        scriptEl.src = WIDGET_SCRIPT_URL;
        scriptEl.dataset.token = data.token;
        scriptEl.dataset.apiBaseUrl = CRM_API_BASE_URL;
        scriptEl.dataset.title = 'Chat con EcoCont';
        // El botón unificado de SupportWidget reemplaza al launcher propio
        // del widget — el panel se controla desde ahí (window.EcoContChat.open/close/toggle).
        scriptEl.dataset.hideLauncher = 'true';
        document.body.appendChild(scriptEl);
      })
      .catch(() => {
        // Sin chat disponible (CRM caído, CHAT_JWT_SECRET no configurado, etc.)
        // — no debe romper el resto de la app.
      });

    return () => {
      cancelled = true;
      scriptEl?.remove();
    };
  }, []);
}
